// extracted by mini-css-extract-plugin
export default {"container":"Code_container__95w5T","fetching":"Code_fetching__Tmqit","code":"Code_code__h-1IQ","codeItem":"Code_codeItem__XP2zY","empty":"Code_empty__OzviF"};